import axios from 'axios';
import { V3_BASE_URL } from '@appmaker/core/api/core';
const BASE_URL = V3_BASE_URL + '/projects';

const api = {
	getActionList: async ({ projectId }) => {
		try {
			const response = await axios
				.get(`${BASE_URL}/${projectId}/actions`, {
					credentials: 'include',
					withCredentials: true,
				});
			return response.data;
		} catch (error) {
			throw error;
		}
	},
	updateAction: async ({ projectId, formData }) => {
		try {
			const response = await axios.post(
				`${BASE_URL}/${projectId}/actions`,
				formData,
				{
					credentials: 'include',
					withCredentials: true,
				});
			return response.data;
		} catch (error) {
			throw error;
		}
	}
}

export default api;